<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/tabs-result/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_result') }} ({{ resultProject.name }})
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('fertilization') }}</span>
      </template>
    </navbar>
    <f7-toolbar
      tabbar
      top
      class="tab-class"
      :class="`color-tab-${selection}`"
    >
      <f7-link
        tab-link
        route-tab-id="tab-extract"
        href="./extract/"
        @click="setTabActive('extract')"
      >
        {{ $t('result.manure.tab_extraction_nutWeek') }}
      </f7-link>
      <f7-link
        tab-link
        route-tab-id="tab-nutGround"
        href="./nutGround/"
        @click="setTabActive('groundNutritionReport')"
      >
        {{ $t('result.manure.tab_info_nutGround') }}
      </f7-link>
      <f7-link
        tab-link
        route-tab-id="tab-recommendation"
        href="./recommendation/"
        @click="setTabActive('recommendation')"
      >
        {{ $t('result.manure.tab_recommendation_week') }}
      </f7-link>
      <f7-link
        tab-link
        route-tab-id="tab-seasonal"
        href="./seasonal/"
        @click="setTabActive('seasonal')"
      >
        {{ $t('result.manure.tab_seasonal_overview_values') }}
      </f7-link>
    </f7-toolbar>
    <f7-tabs
      routable
      animated
    >
      <f7-tab
        id="tab-extract"
        class="page-content padding-top-half"
      >
        <TabExtractionsNutr
          v-if="currentTab === 'extract'"
        />
      </f7-tab>
      <f7-tab
        id="tab-nutGround"
        class="page-content padding-top-half"
      >
        <TabGroundNutritionReport
          v-if="currentTab === 'groundNutritionReport'"
        />
      </f7-tab>
      <f7-tab
        id="tab-recommendation"
        class="page-content padding-top-half"
      >
        <TabRecommendationWeek
          v-if="currentTab === 'recommendation'"
        />
      </f7-tab>
      <f7-tab
        id="tab-seasonal"
        class="page-content padding-top-half"
      >
        <TabSeasonalOverview
          v-if="currentTab === 'seasonal'"
        />
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navbar from '../../../../../components/navbar/NavBar.vue';
import TabExtractionsNutr from '../../../../../components/manureResult/tabExtractionsNutr/index.vue';
import TabRecommendationWeek from '../../../../../components/manureResult/recomendationWeek/index.vue';
import TabGroundNutritionReport from '../../../../../components/manureResult/groundNutritionReport/index.vue';
import TabSeasonalOverview from '../../../../../components/manureResult/seasonalOverview/index.vue';

export default {
  name: 'DetailsManurePage',
  components: {
    navbar,
    TabExtractionsNutr,
    TabRecommendationWeek,
    TabSeasonalOverview,
    TabGroundNutritionReport,
  },
  data() {
    return {
      extractionsData: [],
      recomendationFormat: [],
      loaded: false,
    };
  },
  computed: {
    ...mapState('Utilities', ['currentTab']),
    ...mapState('Result', [
      'resultProject',
    ]),
    ...mapState('authentication', ['selection']),
  },
  methods: {
    setTabActive(tabSelected) {
      this.setCurrentTab(tabSelected);
    },
    ...mapActions('Utilities', ['setCurrentTab']),
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../../css/mixins";
.tab-class a.link{
  color: #FF7F26;
  font-style: normal;
  font-weight: 600;
  text-align: center;
  white-space: normal;
  overflow: hidden;
  font-size: x-small;
  @include md {
    font-size: medium;
  }
}
</style>
